import { FC, useState } from "react";
import Stack from "@mui/material/Stack";
import { GridApi } from "ag-grid-community";
import { StackProps } from "@mui/material";
import { grey } from "@mui/material/colors";
import { SavingsOpportunitiesTableToolbar } from "@/components/pages/savings-opportunities/components/toolbar/SavingsOpportunitiesTableToolbar";
import { SavingsOpportunitiesDataGrid } from "@/components/pages/savings-opportunities/components/SavingsOpportunitiesDataGrid";
import { useAppSelector } from "@/store/hooks";
import { savingsOpportunitiesDataSelector } from "@/store/savings-opportunities/selectors/savingsOpportunitiesDataSelector";
import { BillingExplorerSavingOpportunitiesMetaData } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/saving-opportunities/drawer/BillingExplorerSavingOpportunitiesMetaData";

import { SavingsOpportunitiesTopOpportunities } from "@/components/pages/savings-opportunities/components/metadata/top-opportunities/SavingsOpportunitiesTopOpportunities";
import { billingExplorerSavingOpportunitiesDefaultHiddenColumns } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/saving-opportunities/utils/constants";
import { BillingExplorerSavingOpportunitiesDataGridToolbarLeftSide } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-metadata/components/saving-opportunities/drawer/BillingExplorerSavingOpportunitiesDataGridToolbarLeftSide";

export const BillingExplorerSavingOpportunitiesDrawerBody: FC = () => {
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const data = useAppSelector(savingsOpportunitiesDataSelector);

  return (
    <Stack height="100%" spacing={1.5} px={1.5}>
      <BillingExplorerSavingOpportunitiesMetaData gridApi={gridApi} />

      <SavingsOpportunitiesTopOpportunities
        wrapperStackProps={wrapperStackProps}
      />

      <SavingsOpportunitiesTableToolbar gridApi={gridApi}>
        <BillingExplorerSavingOpportunitiesDataGridToolbarLeftSide />
      </SavingsOpportunitiesTableToolbar>

      <SavingsOpportunitiesDataGrid
        data={data}
        gridApi={gridApi}
        setGridApi={setGridApi}
        wrapperStyles={gridWrapperStyles}
        hiddenColumns={billingExplorerSavingOpportunitiesDefaultHiddenColumns}
      />
    </Stack>
  );
};

const gridWrapperStyles = {
  border: 1,
  minHeight: 500,
  borderColor: grey[300],
  borderRadius: 1,
  ".ag-header": {
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
  },
};

const wrapperStackProps: StackProps = {
  direction: "row",
  spacing: 5,
  py: 1.5,
};
